import { render, staticRenderFns } from "./GetCode.vue?vue&type=template&id=1977ad28&scoped=true"
import script from "./GetCode.vue?vue&type=script&lang=js"
export * from "./GetCode.vue?vue&type=script&lang=js"
import style0 from "./GetCode.vue?vue&type=style&index=0&id=1977ad28&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1977ad28",
  null
  
)

export default component.exports